{
    "Page_Title": "Administratoraktionen",
    "Action_Label_MC": "Anruf tätigen",
    "Action_Label_MCC": "Beratungsgespräch",
    "Action_Label_MDT": "DTMF-Ton wählen",
    "Action_Label_CC": "Clear Call (über die Anrufsteuerung)",
    "Action_Label_CCCM": "Clear Call (über das Anrufmodell)",
    "Action_Label_CX": "Klare Verbindung",
    "Action_Label_AC": "Anruf entgegennehmen",
    "Action_Label_HD": "Anruf halten",
    "Action_Label_PC": "Parkanruf",
    "Action_Label_RC": "Anruf abrufen",
    "Action_Label_ATC": "Alternativer Anruf",
    "Action_Label_PUC": "Abholanruf",
    "Action_Label_TO": "Transfer One Step",
    "Action_Label_TR": "Übertragung abgeschlossen",
    "Action_Label_DF": "Anruf umleiten\/ablehnen",
    "Action_Label_MONC": "Monitoranschluss",
    "Action_Label_REC": "Anruf aufzeichnen",
    "Action_Label_CBMSG": "Rückruf registrieren",
    "Action_Label_CO": "Konferenzteilnahme",
    "Action_Label_MES": "Monitorstart",
    "Action_Label_MEP": "Monitorstopp",
    "Action_Label_SDND": "DNS-Status festlegen",
    "Action_Label_SACD": "ACD-Status einstellen",
    "Action_Label_SFWD": "Weiterleitungsstatus festlegen",
    "Action_Label_SACC": "Kontocode festlegen",
    "Action_Label_SPWD": "Entitätspasswort festlegen",
    "Action_Label_QDND": "DND-Status abfragen",
    "Action_Label_QACD": "ACD-Status abfragen",
    "Action_Label_QFWD": "Status der Anfrageweiterleitung",
    "Action_Label_SPC": "Momentaufnahmeanruf",
    "Action_Label_SPD": "Schnappschussgerät",
    "AcdOption_SignIn": "Anmelden",
    "AcdOption_SignOut": "Abmelden",
    "AcdOption_Available": "Verfügbar",
    "AcdOption_NotAvailable": "Nicht verfügbar",
    "AcdOption_AlertingAcd": "Alarmierung (ACD)",
    "AcdOption_AlertingNonAcd": "Alarmierung (Nicht-ACD)",
    "AcdOption_BusyAcd": "Beschäftigt (ACD)",
    "AcdOption_BusyNonAcd": "Beschäftigt (Nicht ACD)",
    "AcdOption_BusySupervisor": "Beschäftigt (Vorgesetzter)",
    "AcdOption_AcdDnd": "ACD-DND",
    "AcdOption_WrapUp": "Einpacken",
    "ForwardOption_None": "Keiner",
    "ForwardOption_Immediate": "Sofort",
    "ForwardOption_OnBusy": "Beschäftigt",
    "ForwardOption_NoAnswer": "Keine Antwort",
    "ForwardOption_OnDnd": "Auf „Nicht stören“",
    "ForwardOption_OnOos": "Auf OOS",
    "Field_Label_DeviceMain": "Gerät",
    "Field_Label_Destination": "Ziel",
    "Field_Label_CallIDMain": "Aktive Anrufer-ID",
    "Field_Label_DestinationAutoPrefix": "Automatisches Präfix für das Ziel?",
    "Field_Label_CallIDHeld": "Andere Anrufer-ID",
    "Field_Label_DTMFTones": "DTMF-Töne",
    "Field_Label_ParkLocation": "Parkstandort",
    "Field_Label_OtherCallID": "Andere Anrufer-ID",
    "Field_Label_DeviceToPickupAt": "Gerät abzuholen bei",
    "Field_Label_CallParked": "Anruf geparkt",
    "Field_Label_MonitorType": "Monitortyp",
    "Field_Label_Password": "Passwort",
    "Field_Label_UseSecurePassword": "Sicheres Passwort verwenden?",
    "Field_Label_MonitorCrossRefID": "Monitor Cross Ref ID",
    "Field_Label_IsDND": "Nicht stören ein\/aus",
    "Field_Label_AgentID": "Agenten-ID",
    "Field_Label_ACDGroup": "ACDGroup",
    "Field_Label_ACDStateReasonTextID": "ACDStateReasonTextID",
    "Field_Label_ACDStatus": "ACD-Status",
    "Field_Label_ForwardMode": "Weiterleitungsstatus",
    "Field_Label_AccountCode": "Kontonummer",
    "Field_Label_PasswordOld": "Altes Passwort",
    "Field_Label_PasswordNew": "Neues Passwort",
    "Field_Label_TelephonyServer": "Telefonieserver",
    "Field_Label_Partition": "Partition",
    "Field_Label_CME": "CME",
    "Action_Button_Label_Execute": "Ausführen",
    "Action_Button_Label_Reset": "Zurücksetzen",
    "NAME": "AdminActionsLanguage",
    "Action_Label": "Aktion",
    "Action_Label_GUC": "Richtlinie zur Benutzerkonformität anfordern",
    "Action_Label_AAP": "Akixi-Erfassungsrichtlinie anwenden",
    "Action_Label_QPS": "Anwesenheitsstatus abfragen",
    "Action_Label_DUP": "Benutzerrichtlinie löschen",
    "Action_Label_GT": "Mieter finden",
    "Action_Label_DT": "Mandant löschen",
    "Action_Label_GU": "Benutzer abrufen",
    "Action_Label_GVA": "Sprach-Apps herunterladen",
    "Field_Label_SilentMonitor": "Silent Monitor",
    "Field_Label_ForcedIntrude": "Gewaltsames Eindringen",
    "Field_Label_Policies": "Richtlinien"
}